// @ts-nocheck
import * as React from "react";
import getIconDataSrc from "@toolkit/Framework/Common/Utilities/getIconDataSrc";

const Checkmark: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path fill="currentColor" d="m9.55 17.308-4.97-4.97.714-.713 4.255 4.256 9.156-9.156.714.714-9.87 9.869Z" />
        </svg>
        /* Store Custom Code - End */
    );
};

export const CheckmarkDataSrc = getIconDataSrc(Checkmark);

export default React.memo(Checkmark);
